import { Box, Slider, TextField, Typography } from "@mui/material";
import React from "react";
import { getColor } from "../../../style/color/color";
import { StyledQuestionTypography } from "../../../style/styleComponents/StyledFutureGoal";
import { numberToWords } from "../../../logic/NumberToWord";
import { formatToIndianCurrency } from "../../../logic/CurrencyFormatter";
import { String } from "../../../constants/Strings";

const GoalSlider = ({ income, setIncome, question }) => {
  const handleSliderChange = (event, newValue) => {
    setIncome(newValue);
  };

  const handleTextFieldChange = (event) => {
    const numericValue = event.target.value.replace(/[^0-9]/g, "");

    if (numericValue === "") {
      setIncome(0);
    } else {
      const value = parseInt(numericValue, 10);
      if (!isNaN(value)) {
        setIncome(value);
      }
    }
  };

  return (
    <Box>
      <StyledQuestionTypography>{question}</StyledQuestionTypography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          mt: 2,
        }}
      >
        <TextField
          value={formatToIndianCurrency(income) || `₹${income}`}
          type="tel"
          onChange={handleTextFieldChange}
          placeholder={String.Retirement.FutureGoal.goalAmountPlaceholder}
          InputProps={{
            type: "tel",
            disableUnderline: true,
            sx: {
              textAlign: "center",
            },
          }}
          variant="standard"
          sx={{
            width: "80%",
            maxWidth: "300px",
            borderRadius: 3,
            border: "0.50px #505662 solid",
            textAlign: "center",
            p: "10px",
            mt: "20px",
            "& input": {
              textAlign: "center",
              fontWeight: "600",
            },
          }}
        />
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: { xs: "0.8rem", sm: "0.9rem" },
            textTransform: "initial",
            mt: "10px",
            color: getColor.NeutralDark700,
          }}
        >
          {`Rupees ${numberToWords(income)}`}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: 10,
          borderRadius: 10,
          pl: "20px",
          pr: "20px",
        }}
      >
        <Slider
          value={income}
          valueLabelDisplay="auto"
          onChange={handleSliderChange}
          min={1000000}
          max={20000000}
          step={1000}
          sx={{
            width: "90%",
            p: 1,
            mt: "10px",
            mr: "10px",
            ml: "10px",
            color: getColor.ExtendedpalettesSummerSkySS800,
            "& .MuiSlider-thumb": {
              height: 24,
              width: 24,
              backgroundColor: getColor.PrimaryWhite,
              border: "2px solid currentColor",
              "&:hover": {
                boxShadow: "inherit",
              },
            },
            "& .MuiSlider-track": {
              height: 8,
              borderRadius: 4,
            },
            "& .MuiSlider-rail": {
              height: 8,
              borderRadius: 4,
              backgroundColor: "rgba(0, 0, 0, 0.10)",
            },
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: "35px",
          ml: "20px",
          mr: "20px",
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            color: getColor.Grey,
          }}
        >
          ₹10,00,000
        </Typography>

        <Typography
          sx={{
            fontSize: 12,
            color: getColor.Grey,
          }}
        >
          ₹2,00,00,000
        </Typography>
      </Box>
    </Box>
  );
};

export default GoalSlider;
